import { Link, useSearchParams } from "react-router-dom";
import SiteHeader from "@/components/feature/SiteHeader";
import SiteFooter from "@/components/feature/SiteFooter";
import VideoCard from "@/components/feature/VideoCard";
import SeoMeta from "@/components/feature/SeoMeta";
import { allVideos, categories } from "@/mocks/videos";

export default function SearchPage() {
  const [params] = useSearchParams();
  const q = (params.get("q") || "").trim().toLowerCase();

  const results = q
    ? allVideos.filter(
        (v) =>
          v.title.toLowerCase().includes(q) ||
          v.desc.toLowerCase().includes(q) ||
          v.tags.some((t) => t.toLowerCase().includes(q)) ||
          categories.find((c) => c.id === v.category)?.name.toLowerCase().includes(q),
      )
    : [];

  return (
    <div className="bg-background-50 min-h-screen">
      <SeoMeta
        title={`搜索 ${q} - 国产吃瓜视频`}
        description={`搜索“${q}”为你找到 ${results.length} 条相关的国产吃瓜视频合集、精选与热门推荐内容。`}
        type="website"
      />
      <SiteHeader />

      <div className="mx-auto max-w-7xl px-4 md:px-6 pt-24 md:pt-32 pb-14 md:pb-20">
        <nav className="flex items-center gap-1 text-sm text-foreground-500 mb-6 flex-wrap">
          <Link to="/" className="hover:text-primary-600">首页</Link>
          <i className="ri-arrow-right-s-line"></i>
          <span>搜索</span>
        </nav>

        <div className="bg-background-100 rounded-2xl p-6 md:p-8 text-center">
          <h1 className="font-heading text-2xl md:text-3xl font-black text-foreground-950">
            搜索“<span className="text-primary-600">{q}</span>”
          </h1>
          <p className="mt-2 text-sm text-foreground-600">为你找到 {results.length} 条相关的吃瓜视频</p>
        </div>

        {results.length > 0 ? (
          <div className="mt-8 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
            {results.map((v) => (
              <VideoCard key={v.id} video={v} />
            ))}
          </div>
        ) : (
          <div className="mt-10 text-center py-14">
            <i className="ri-inbox-line text-5xl text-foreground-300"></i>
            <p className="mt-4 text-foreground-600">没有找到相关视频，换个关键词试试，或浏览以下热门分类</p>
            <div className="mt-6 flex flex-wrap items-center justify-center gap-2">
              {categories.map((c) => (
                <Link
                  key={c.id}
                  to={`/category/${c.id}`}
                  className="px-4 py-1.5 rounded-full bg-primary-100 text-primary-700 text-sm font-semibold hover:bg-primary-200 transition-colors"
                >
                  {c.name}
                </Link>
              ))}
            </div>
          </div>
        )}
      </div>

      <SiteFooter />
    </div>
  );
}